import getFieldRequirementP5 from './p5/fieldRequirementResolver'
import getFieldRequirementP6 from './p6/fieldRequirementResolver'
import { toFieldRequirementResolverContext } from './types'
import { createGetFieldRequirementWithParentLookup } from '../../resolverFactory'
import { FieldRequirement } from '../../../../../models/fieldRules'
import { GetDeclarationFormFieldRequirementContext } from '../../types'

function getFieldRequirement(path: string, ctx: GetDeclarationFormFieldRequirementContext) {
  const fieldRequirementContext = toFieldRequirementResolverContext(path, ctx)

  return ctx.phase === 'p5' ? getFieldRequirementP5(path, fieldRequirementContext) : getFieldRequirementP6(path, fieldRequirementContext)
}

export const baseGetFieldRequirement = (
  path: string,
  ctx: GetDeclarationFormFieldRequirementContext,
): FieldRequirement => {
  const requirement = getFieldRequirement(path, ctx)
  if (!requirement) return 'optional'

  return requirement
}

export const getTransitTransitOperationFieldRequirement = createGetFieldRequirementWithParentLookup(baseGetFieldRequirement)
